import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-input',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
            <div [id]="field.key" [formGroup]="form" [class]="'form-group schema-form-radiobuttons has-feedback ' + props['htmlClass']"
            [class.has-success]="formControl.status === 'VALID'"
            [class.has-error]="formControl.status === 'INVALID'">
                <label *ngIf="props['title']"
                    [class]="props['labelHtmlClass'] || ''"
                    [style.display]="!props['title'] ? 'none' : ''"
                    [innerHTML]="props['title']">
                </label>
                <div class="btn-group toggle-buttons">
                    <div
                      [class]="props['htmlClass'] || ''">
                      <label *ngFor="let option of props.options"
                            [class]="'btn btn-secondary ' + (props['itemLabelHtmlClass'] || '') +
                              ((formControl.value + '' === option.value + '') ?
                              (' ' + (props['activeClass'] || '') + ' ' + (props['style']?.selected || '')) :
                              (' ' + (props['style']?.unselected || '')))">
                            <input type="radio" hidden
                            [formControl]="formControl"
                            [formlyAttributes]="field"
                              [attr.readonly]="props['readonly'] ? 'readonly' : null"
                              [attr.required]="props['required']"
                              [attr.name]="field.key"
                              [checked]="option.value === formControl.value"
                              [class]="props['fieldHtmlClass']|| ''"
                              [value]="option.value"
                              [formControlName]="field.key"
                            >
                        <span [innerHTML]="option.name"></span>
                      </label>
                    </div>
                </div>
                <div *ngIf="(formControl.dirty || formControl.touched) && formControl.status === 'INVALID'" class="help-block">
                    {{props['description']}}
                    <formly-validation-message [field]="field"></formly-validation-message>
                </div>
            </div>
  `
})
export class RadioFieldTypeComponent extends FieldType<FieldTypeConfig> { }
